

import action from './action';
import { share } from 'utils/wx';
import Icon from 'vux/src/components/icon/index.vue'

import { yoButton } from 'components';

export default {
name: 'index',
props: ['params'],
metaInfo() {
return {
title: this.pageTitle
};
},
created: async function () {
this.getInfo();
},
data() {
return {
pageTitle: '邀请您成为TA的会员',
sendBtnShow: false,
sendCodeText: '获取验证码',
sendSpeechText: '语音获取',
speechBtnShow: false,//语音获取
speechViewShow: false,//语音验证按钮显示
showSpeechDialog: false,//语音弹窗显示
nums: 60,
speechTime: 60,
isGetting: false,//正在获取
phone: '',
authCode: '',
enterprise: this.params.enterprise,
refereesInfo: {},
inviteCode: this.params.inviteCode
};
},
mounted () {
this.bfscrolltop = document.body.scrollTop
},
computed: {},
filters: {},
components: {
Icon,
yoButton
},
methods: {
...action,
onInputFocus() {

},
onInputBlur() {
document.body.scrollTop = this.bfscrolltop
}
},
beforeRouteEnter(to, from, next) {
next();
},
beforeRouteUpdate(to, from, next) {
next();
}
};



// WEBPACK FOOTER //
// ./src/module/member/login/page.vue